var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-title"},[_c('h1',{style:({ padding: _vm.padding })},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle !== false)?_c('h4',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }